import axios from "axios";
import { message } from "antd";

// الإعدادات تأتي من ملف .env (راجع .env.example).
// للتبديل بين الإنتاج والاختبار: عدّل .env.local — لا تعلّق أسطراً في الكود.
export const baseUrl =
  process.env.REACT_APP_API_BASE_URL || "https://www.book-makan.com/api/admin/";

const apiKey = process.env.REACT_APP_API_KEY || "";

if (!process.env.REACT_APP_API_BASE_URL) {
  console.warn(
    "[api] REACT_APP_API_BASE_URL غير معرّف — تم استخدام رابط الإنتاج الافتراضي. أنشئ ملف .env.",
  );
}

// اقرأ التوكن من التخزين عند كل طلب، لا مرة واحدة عند تحميل الصفحة،
// حتى ينعكس تسجيل الدخول أو تجديد التوكن فوراً بدون إعادة تحميل.
export const getToken = () => localStorage.getItem("tokenAdmin") || "";

// متوافق مع الاستخدام القديم (روابط الرفع المباشرة)؛ يفضّل استخدام getToken().
export const tokenAdmin = getToken();

const attachAuth = (instance) => {
  instance.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["api-key"] = apiKey;
    return config;
  });
  return instance;
};

const clearSession = () => {
  localStorage.removeItem("tokenAdmin");
  localStorage.removeItem("authNameAdmin");
  localStorage.removeItem("loggedInAdmin");
  localStorage.removeItem("permissionsAdmin");
};

// يستخرج رسالة مفهومة من أي شكل خطأ يرجعه الـ backend
export const extractErrorMessage = (error) => {
  const data = error?.response?.data;

  if (!error?.response) {
    return "تعذّر الاتصال بالخادم. تحقق من اتصال الإنترنت.";
  }
  if (typeof data?.message === "string" && data.message) return data.message;
  if (typeof data?.errors === "string" && data.errors) return data.errors;
  if (data?.errors && typeof data.errors === "object") {
    const first = Object.values(data.errors)[0];
    if (Array.isArray(first) && first[0]) return first[0];
  }
  if (error.response.status === 403) return "لا تملك صلاحية لهذا الإجراء.";
  if (error.response.status === 404) return "العنصر المطلوب غير موجود.";
  if (error.response.status >= 500) return "خطأ في الخادم. حاول لاحقاً.";
  return "حدث خطأ غير متوقع.";
};

const axiosApi = attachAuth(
  axios.create({
    baseURL: baseUrl,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "api-key": apiKey,
    },
  }),
);

const axiosApi1 = attachAuth(
  axios.create({
    baseURL: baseUrl,
    headers: {
      "Content-Type": "multipart/form-data",
      "api-key": apiKey,
    },
  }),
);

export { axiosApi1 };

const handleAuthRedirects = (error) => {
  const status = error?.response?.status;
  const data = error?.response?.data;
  const messageText = typeof data?.message === "string" ? data.message : "";
  const errorsText = typeof data?.errors === "string" ? data.errors : "";

  if (status === 401 || messageText.includes("Unauthenticated")) {
    clearSession();
    window.location.href = "/login";
    return true;
  }

  if (
    errorsText === "Property is not found" ||
    messageText === "Property is not found" ||
    errorsText === "القيمة المحددة code غير موجودة"
  ) {
    localStorage.removeItem("codeAddProperty");
    window.location.href = "/add-property/step-1";
    return true;
  }

  if (status === 403 || data?.code === 403) {
    // بعض الشاشات (لوحة المؤشرات) تُطلق عدة طلبات متوازية، وقد لا يملك المستخدم
    // صلاحية بعضها. تحويل الصفحة كلها إلى /403 بسبب طلب فرعي واحد يُفقده الشاشة
    // بأكملها، فنسمح للطلب أن يطلب استثناءه عبر skipForbiddenRedirect.
    if (error?.config?.skipForbiddenRedirect) {
      return false;
    }

    window.location.href = "/403";
    return true;
  }

  return false;
};

[axiosApi, axiosApi1].forEach((instance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      // ملاحظة: يستخدم optional chaining لأن أخطاء الشبكة لا تحتوي على response
      handleAuthRedirects(error);
      return Promise.reject(error);
    },
  );
});

// يبني query string ويتجاهل القيم الفارغة، حتى لا تضيع الفلاتر
// عند التنقل بين الصفحات ولا تُرسل بارامترات فارغة بلا داعٍ.
export const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    search.append(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : "";
};

// ترجع undefined عند الفشل (كما كان سابقاً حتى لا تنكسر الشاشات الحالية)
// لكنها الآن تُظهر سبب الفشل بدل الصمت التام.
//
// config.silent يكتم رسالة الخطأ للمستخدم، ويمنع أيضاً التحويل التلقائي إلى /403
// لأن الطلبات الصامتة تكون طلبات فرعية لا يصح أن يُسقط فشلُها الشاشة كلها.
export async function get(url, config = {}) {
  try {
    const response = await axiosApi.get(url, {
      skipForbiddenRedirect: !!config.silent,
      ...config,
    });
    return response.data;
  } catch (err) {
    if (!config.silent) {
      message.error(extractErrorMessage(err));
    }
    console.error(`[api] GET ${url} فشل:`, err);
    return undefined;
  }
}

export async function postFromData(url, data, config = {}) {
  const formData = new FormData();
  const dataList = data;
  for (let item in dataList) {
    formData.append(item, dataList[item]);
  }
  return axiosApi.post(url, formData).then((res) => res.data);
}

export async function newPostFromData(url, data, config = {}) {
  const arrayData = {};
  const dataList = data;
  for (let item in dataList) {
    arrayData[item] = dataList[item];
  }
  return axiosApi.post(url, { ...arrayData }).then((res) => res.data);
}

export async function post(url, data) {
  return axiosApi.post(url, data).then((res) => res.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function patch(url, data, config = {}) {
  return axiosApi
    .patch(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function putFromData(url, data, config = {}) {
  const formData = new FormData();
  const dataList = data;
  for (let item in dataList) {
    formData.append(item, dataList[item]);
  }
  return axiosApi.put(url, formData).then((res) => res.data);
}

export async function del(url, config = {}) {
  return await axiosApi.delete(url).then((response) => response.data);
}

export default axiosApi;
